export { Cteamcard } from './Cteamcard';
export type { CteamcardProps, TeamData } from './Cteamcard';
